import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import { Dobra, LoopDiagram, color, type LoopNode } from '../../brand'
import { trackCTAClick } from '../../utils/analytics'

const env = import.meta.env as Record<string, string | undefined>
const GENESIS_SIGNUP_URL = env.VITE_GENESIS_SIGNUP_URL || ''
const CLOSED: LoopNode[] = Array.from({ length: 8 }, (_, i) => ({ t: i / 8, state: 'cura' }))

/**
 * Bloco de contato que fecha cada página (modelo do Ângelo): "Conte o seu contexto." + laço fechado em Cura pulsando.
 * O CTA primário vai SEMPRE para /contacts (o formulário com endpoint e estados) — a crítica do próprio modelo apontou que o mesmo
 * rótulo levava a destinos diferentes. "Criar conta no Genesis" só aparece com URL real (VITE_GENESIS_SIGNUP_URL); sem ela, não se
 * promete uma conta que não existe.
 */
export function ContactBlock({ page, surface = 'dark' }: { page: string; surface?: 'dark' | 'light' }) {
  const { t } = useTranslation()
  return (
    <Dobra surface={surface} kicker={t('brand.pages.contacts.kicker')} title={t('brand.pages.contacts.title')} lede={t('model.contactBlock.lede')} aside={<LoopDiagram nodes={CLOSED} pulse pulseColor={color.cura} pulseDuration={7} />}>
      <p className="z-cta-row">
        <Button component={Link} to="/contacts" variant="contained" onClick={() => trackCTAClick(`${page}.cta.final`, 'cta-final', page)}>{t('model.contactBlock.primary')}</Button>
        {GENESIS_SIGNUP_URL && <Button href={GENESIS_SIGNUP_URL} target="_blank" rel="noopener noreferrer" variant="outlined" onClick={() => trackCTAClick(`${page}.cta.genesis-signup`, 'cta-final', page)}>{t('model.contactBlock.genesis')}</Button>}
      </p>
      <p className="z-cta-nota">{t('model.contactBlock.direct')} <a href="mailto:contato@zentriz.com.br">contato@zentriz.com.br</a></p>
    </Dobra>
  )
}
